// require("preact/debug");

import Registration from "./Registration";
import DatePicker from "./datepicker";
import MiniCart from "./MiniCart";
import MyAccount from "./MyAccount";
import Product from "./Product";
import BranchSelection from "./branch-selection/BranchSelection";
import PreferredBranchBarMobile from "./branch-selection/PreferredBranchBarMobile";
import AccountIcon from "./account-icon/AccountIcon";
import { h, render } from "preact";
import { library, dom } from "@fortawesome/fontawesome-svg-core";

import { faCaretRight, faCaretDown, faCaretLeft, faShoppingCart } from "@fortawesome/pro-solid-svg-icons";
import {
    faSpinner,
    faBagsShopping,
    faBars,
    faChartLine,
    faUserCog,
    faCalendarAlt,
    faTreasureChest,
    faSignOut,
    faMinus,
    faPlus,
    faTimes,
} from "@fortawesome/pro-light-svg-icons";
import Shop from "./Shop";

const replaceAll = require("string.prototype.replaceall");
replaceAll.shim();
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

new DatePicker();
new MiniCart();
new MyAccount();
new Product();
new Registration();

window.showLocationModal = function() {
    // wait for the modal to be loaded and then call the function
    setTimeout(() => {
        console.log("showLocationModalStub");
        (function() {
            window.showLocationModal();
        })();
        // eval(`(function() {
        // 	window.showLocationModal();})()`)
    }, 1000);
};

document.addEventListener("DOMContentLoaded", () => {
    // If there is a notice that is '[data-id="select-location-notice"]' then show the modal
    // This occurs when a user needs to select a location before they can continue
    if (document.querySelector('[data-id="select-location-notice"]')) {
        window.showLocationModal();
    }

    new Shop();

    let selectedClinicClass = "gumnut-selected-clinic";

    let yourAccountClass = "gumnut-your-account";

    let mobileSelectedMenu = "mobile-menu";

    if (document.querySelectorAll("." + selectedClinicClass)) {
        document.querySelectorAll("." + selectedClinicClass).forEach((el) => {
            render(<BranchSelection />, el);
        });
    }

    if (document.querySelectorAll("." + yourAccountClass)) {
        document.querySelectorAll("." + yourAccountClass).forEach((el) => {
            const baseUrl = window.location.origin;
            if (baseUrl.includes("clickclick")) {
                render(<AccountIcon href={"https://web.clickclick.media/_zfromlive/the_cosmetic_clinics_2023/my-account"} />, el);
            } else {
                render(<AccountIcon href={"/my-account"} />, el);
            }
        });
    }

    if (document.querySelectorAll("." + mobileSelectedMenu)) {
        document.querySelectorAll("." + mobileSelectedMenu).forEach((el) => {
            render(<PreferredBranchBarMobile />, el);
        });
    }
});

library.add(
    faChartLine,
    faCaretRight,
    faCaretDown,
    faCaretLeft,
    faUserCog,
    faCalendarAlt,
    faTreasureChest,
    faSignOut,
    faMinus,
    faPlus,
    faBars,
    faShoppingCart,
    faBagsShopping,
    faSpinner,
    faTimes
);
dom.watch();

let forms = [".woocommerce-form-login", ".woocommerce-form-register", ".woocommerce-EditAccountForm", ".woocommerce-ResetPassword"];

document.addEventListener("DOMContentLoaded", () => {
    forms.forEach((formQuerySelector) => {
        let el = document.querySelector(formQuerySelector);

        if (el) {
            el.addEventListener("submit", () => {
                let button = el.querySelector('button[type="submit"]');

                button.classList.add("disabled");
                button.innerHTML = '<span class="button-loader"></span>' + button.innerHTML;
            });
        }
    });
});
